import { render, staticRenderFns } from "./EquiposyPerifericosCrm.vue?vue&type=template&id=5d4c334c&"
import script from "./EquiposyPerifericosCrm.vue?vue&type=script&lang=ts&"
export * from "./EquiposyPerifericosCrm.vue?vue&type=script&lang=ts&"
import style0 from "./EquiposyPerifericosCrm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5d4c334c', component.options)
    } else {
      api.reload('5d4c334c', component.options)
    }
    module.hot.accept("./EquiposyPerifericosCrm.vue?vue&type=template&id=5d4c334c&", function () {
      api.rerender('5d4c334c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/AltasCrm/EquiposyPerifericosCrm.vue"
export default component.exports